import React from 'react';
import './SkillsCloud.css';

export default function SkillsCloud() {
  // Skills organized by categories
  const skillCategories = {
    Frontend: [
      { key: 'react', name: 'React' },
      { key: 'flutter', name: 'Flutter' },
      { key: 'vite', name: 'Vite' },
      { key: 'angular', name: 'Angular' },
      { key: 'nextjs', name: 'Next.js' },
      { key: 'remix', name: 'Remix' },
      { key: 'javascript', name: 'JavaScript' },
      { key: 'typescript', name: 'TypeScript' },
      { key: 'html', name: 'HTML' },
      { key: 'css', name: 'CSS' },
      { key: 'tailwind', name: 'Tailwind CSS' },
      { key: 'bootstrap', name: 'Bootstrap' },
      { key: 'materialui', name: 'Material-UI' },
      { key: 'styledcomponents', name: 'Styled Components' },
            { key: 'gulp', name: 'Gulp' },
    { key: 'jquery', name: 'jQuery' },
      { key: 'htmx', name: 'HTMX' },
      { key: 'webpack', name: 'Webpack' },            
    ],
    'Backend and Tools': [
      { key: 'git', name: 'Git' },                
        { key: 'php', name: 'PHP' },
        { key: 'nodejs', name: 'Node.js' },
        { key: 'express', name: 'Express.js' },
        { key: 'heroku', name: 'Heroku' },
        { key: 'deno', name: 'Deno' },
        { key: 'pnpm', name: 'pnpm' },
        { key: 'npm', name: 'npm' },
        { key: 'wordpress', name: 'WordPress' },
        { key: 'postgres', name: 'PostgreSQL' },
        { key: 'mysql', name: 'MySQL' },
        { key: 'sqlite', name: 'SQLite' },
        { key: 'firebase', name: 'Firebase' },
        { key: 'supabase', name: 'Supabase' },
        { key: 'aws', name: 'AWS' },
        { key: 'cloudflare', name: 'Cloudflare' },
        { key: 'gcp', name: 'Google Cloud' },
      { key: 'vscode', name: 'VS Code' },
      { key: 'vim', name: 'Vim' },
      { key: 'sublime', name: 'Sublime Text' },
      { key: 'powershell', name: 'PowerShell' },
      { key: 'ubuntu', name: 'Ubuntu' },
      { key: 'linux', name: 'Linux' },
      { key: 'mint', name: 'Linux Mint' },
      { key: 'windows', name: 'Windows' },
      { key: 'markdown', name: 'Markdown' },
      { key: 'obsidian', name: 'Obsidian' },
      { key: 'notion', name: 'Notion' },
      { key: 'devto', name: 'Dev.to' }
    ]
  };

  return (
    <div className="skills-cloud">
      {/* <h3>Favorite Stacks</h3> */}
      
      {Object.entries(skillCategories).map(([category, skills]) => (
        <div key={category} className="skills-category">
          <h4 className="category-title">{category}</h4>
          <div className="skills-grid">
            {skills.map((skill) => (
              <div key={skill.key} className="skill-item">
                <img 
                  src={`https://skillicons.dev/icons?i=${skill.key}`}
                  alt={skill.name}
                  className="skill-icon"
                />
                <span className="skill-name">{skill.name}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}